export default __webpack_public_path__ + "static/media/step-two-2.1e7046c9.png";